export default __webpack_public_path__ + "static/SuisseIntl-Regular-WebS-241746f3242dd08a7b7896b1f837c722.eot";